/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_ReviewsInputs */

const id_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulasan`)
};

const ms_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulasan`)
};

const da_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldelser`)
};

const de_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertungen`)
};

const en_us2_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviews`)
};

const es_es2_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reseñas`)
};

const es_mx2_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reseñas`)
};

const fil_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Review`)
};

const fr_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avis`)
};

const it_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recensioni`)
};

const hu_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értékelések`)
};

const nl_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviews`)
};

const no_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omtaler`)
};

const pl_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recenzje`)
};

const pt_br2_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentários`)
};

const pt_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliações`)
};

const ro_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recenzii`)
};

const fi_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arvostelut`)
};

const sv_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recensioner`)
};

const vi_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đánh giá`)
};

const tr_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yorumlar`)
};

const cs_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recenze`)
};

const bg_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ревюта`)
};

const ru_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзоры`)
};

const uk_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відгуки`)
};

const ar_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المراجعات`)
};

const hi_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समीक्षाएँ`)
};

const th_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีวิว`)
};

const ja_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビュー`)
};

const zh_cn2_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评论`)
};

const zh_hant1_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`評論`)
};

const ko_profile_hero_reviews = /** @type {(inputs: Profile_Hero_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리뷰`)
};

/**
* | output |
* | --- |
* | "Reviews" |
*
* @param {Profile_Hero_ReviewsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_reviews = /** @type {((inputs?: Profile_Hero_ReviewsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_ReviewsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_reviews(inputs)
	if (locale === "ms") return ms_profile_hero_reviews(inputs)
	if (locale === "da") return da_profile_hero_reviews(inputs)
	if (locale === "de") return de_profile_hero_reviews(inputs)
	if (locale === "en-US") return en_us2_profile_hero_reviews(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_reviews(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_reviews(inputs)
	if (locale === "fil") return fil_profile_hero_reviews(inputs)
	if (locale === "fr") return fr_profile_hero_reviews(inputs)
	if (locale === "it") return it_profile_hero_reviews(inputs)
	if (locale === "hu") return hu_profile_hero_reviews(inputs)
	if (locale === "nl") return nl_profile_hero_reviews(inputs)
	if (locale === "no") return no_profile_hero_reviews(inputs)
	if (locale === "pl") return pl_profile_hero_reviews(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_reviews(inputs)
	if (locale === "pt") return pt_profile_hero_reviews(inputs)
	if (locale === "ro") return ro_profile_hero_reviews(inputs)
	if (locale === "fi") return fi_profile_hero_reviews(inputs)
	if (locale === "sv") return sv_profile_hero_reviews(inputs)
	if (locale === "vi") return vi_profile_hero_reviews(inputs)
	if (locale === "tr") return tr_profile_hero_reviews(inputs)
	if (locale === "cs") return cs_profile_hero_reviews(inputs)
	if (locale === "bg") return bg_profile_hero_reviews(inputs)
	if (locale === "ru") return ru_profile_hero_reviews(inputs)
	if (locale === "uk") return uk_profile_hero_reviews(inputs)
	if (locale === "ar") return ar_profile_hero_reviews(inputs)
	if (locale === "hi") return hi_profile_hero_reviews(inputs)
	if (locale === "th") return th_profile_hero_reviews(inputs)
	if (locale === "ja") return ja_profile_hero_reviews(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_reviews(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_reviews(inputs)
	return ko_profile_hero_reviews(inputs)
});
export { profile_hero_reviews as "profile.hero.reviews" }